import { captureSafePostHogEvent } from './client';
import type {
  AnalyticsApp,
  AnalyticsReasonCode,
  AuthAction,
  EorAction,
  EorFlow,
  SafePageName,
  ThemePreferenceSource,
  ThemePreferenceValue,
  WalletAction,
  WalletFlow,
} from './types';

interface AuthActionOptions {
  result?: 'success' | 'failure' | 'required';
  reason_code?: AnalyticsReasonCode;
  new_app_access?: boolean;
}

interface SignupCompletedOptions {
  wallet_created: boolean;
}

interface WalletActionOptions {
  flow?: WalletFlow;
  result?: 'started' | 'submitted' | 'success' | 'failure';
  count?: number;
}

interface EorActionOptions {
  flow?: EorFlow;
  result?: 'created' | 'updated' | 'success' | 'failure';
  count?: number;
}

export function trackAuthAction(action: AuthAction, options: AuthActionOptions = {}): void {
  captureSafePostHogEvent('auth_action', {
    app: 'auth-app',
    action,
    ...options,
  });
}

export function trackSignupCompleted(options: SignupCompletedOptions): void {
  captureSafePostHogEvent('signup_completed', {
    app: 'eor-app',
    action: 'completed',
    wallet_created: options.wallet_created,
  });
}

export function trackWalletAction(action: WalletAction, options: WalletActionOptions = {}): void {
  captureSafePostHogEvent('wallet_action', {
    app: 'wallet-app',
    action,
    ...options,
  });
}

export function trackEorAction(action: EorAction, options: EorActionOptions = {}): void {
  captureSafePostHogEvent('eor_action', {
    app: 'eor-app',
    action,
    ...options,
  });
}

export function trackSafePageView(app: AnalyticsApp, page: SafePageName): void {
  captureSafePostHogEvent('safe_page_view', {
    app,
    action: page,
  });
}

interface ThemePreferenceOptions {
  app: AnalyticsApp;
  theme: ThemePreferenceValue;
  source: ThemePreferenceSource;
}

export function trackThemePreference(options: ThemePreferenceOptions): void {
  captureSafePostHogEvent('theme_preference', options);
}

export function toAnalyticsReasonCode(error: Error): AnalyticsReasonCode {
  if ('statusCode' in error && error.statusCode === 403) return 'no_permission';
  return 'request_failed';
}
